module.exports = __webpack_public_path__ + "img/cegp-enigme_full.770f3bad.png";